export default __webpack_public_path__ + "static/media/verd.9bca082b.png";